import { useEffect, useState } from "react";

/**
 * URL temporária para exibir o blob, revogada ao trocar de imagem ou desmontar —
 * sem isso cada print aberto ficaria preso na memória da aba.
 *
 * A miniatura e o diálogo de print usam a mesma regra.
 */
export function useObjectUrl(blob: Blob | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!blob) {
      setUrl(null);
      return;
    }
    const next = URL.createObjectURL(blob);
    setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [blob]);
  return url;
}
